// extracted by mini-css-extract-plugin
module.exports = {"galleryWrap":"QuoteCard_galleryWrap__3MBTs","userWrap":"QuoteCard_userWrap__3oUFG","title":"QuoteCard_title__2rjn9"};